import React from 'react';
import Stopper, { CONTENT } from '@bit/gerenciatd.unifiedcomponents.stopper';
const Error = () => {
  return <Stopper content={CONTENT.ERROR} />;
};

export default Error;
